var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:["list-group-item", {"list-group-item-action": _vm.action, "active": _vm.active, "disabled": _vm.disabled}],attrs:{"href":(_vm.action ? "#" : null)},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.handleClick.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }